'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdNetworkCheck = function MdNetworkCheck(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm8.4 21.6c3.3-3.3 7.8-4.9 12.1-4.7l-2.1 4.7c-2.5 0.4-4.9 1.5-6.8 3.4z m20 3.4c-0.7-0.6-1.4-1.2-2.1-1.6l1-4.9c1.5 0.8 3 1.8 4.3 3.1z m6.6-6.6c-2-2.1-4.4-3.6-6.9-4.6l0.9-4.7c3.4 1.2 6.6 3.2 9.4 5.9z m-33.4-3.4c6.3-6.2 14.9-8.6 22.9-7.2l-1.9 4.5c-6.3-0.8-12.8 1.3-17.6 6.1z m24.9-6.6c0.5 0 0.8 0.3 0.8 0.7l-4 21.5v0.1c-0.3 1.5-1.7 2.7-3.3 2.7-1.9 0-3.4-1.5-3.4-3.4 0-0.5 0.2-1.2 0.4-1.6l8.7-19.4c0.1-0.4 0.4-0.6 0.8-0.6z' })
        )
    );
};

exports.default = MdNetworkCheck;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/network-check.js
// module id = 3100
// module chunks = 0